
$(document).ready(function() {
  $('.featured-reviews').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.home-products__slider').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 6000,
    responsive:{
      0:{
        items:2,
        nav: false
      },
      600:{
        items:2
      },
      1051:{
        items:4
      }
    }
  });
        //Mailchimp on Popup
   $('.newsletter-popup__form .sign_up').click(function(){
          var $form = $('.newsletter-popup__form');
          $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            cache       : false,
            dataType    : 'json',
            contentType: "application/json; charset=utf-8",
            error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
            success     : function(data) {
              if (data.result != "success") {
                var data = data.msg,
                newData = data.replace('1 -','').replace('0 -','');
                $(".newsletter-popup__form .response-text").show().removeClass("success").addClass("error").html(newData);
                setTimeout(function(){ $(".newsletter-popup__form .response-text").hide(); }, 5000);
              }
              else
              {
          //$(".mailchimp-form .response-text").show();
          $(".newsletter-popup__form .response-text").removeClass("error");
          $(".newsletter-popup__form .response-text").addClass("success");
          //$(".mailchimp-form .response-text").html("Please check your email and confirm your subscription.");
          $('#newsletter-popup .newsletter').hide();
          $('#newsletter-popup .newsletter-popup-container p').html("<p>Cheers! <br><br>Have a 10% discount code on us, use code&nbsp;TAKE10&nbsp;at checkout!&nbsp;</p>");
          //setTimeout(function(){ $(".mailchimp-form .response-text").hide(); }, 5000);

        }
      }
    });
  });

   $( ".newsletter-popup__form" ).keypress(function(e) {
    if(e.which == 13) {
      $( ".newsletter-popup__form .sign_up" ).trigger( "click" );
      return false;
    }
  });
              
});